import { takeLatest, call, put } from 'redux-saga/effects'

import listActiveParticipants from 'api/administration/participants/ListActiveParticipants'
import * as fromActions from '../../actions/participants.action'

async function getList(
  page: number,
  area: number[],
  searchText: string,
  sort: any[],
  usersFilter: string,
  perPage: number,
  fastFilters: number
) {
  return listActiveParticipants({
    page,
    area,
    searchText,
    sort,
    usersFilter,
    perPage,
    fastFilters,
  })
}

function* participantsListEffectSaga(action: any) {
  try {
    const {
      page,
      area,
      searchText,
      sort,
      usersFilter,
      perPage: itemsPerPage,
      fastFilters,
    } = action.payload
    const { data, total, perPage } = yield call(
      getList,
      page,
      area,
      searchText,
      sort,
      usersFilter,
      itemsPerPage,
      fastFilters
    )
    yield put(
      fromActions.Actions.participantsProfilesListSuccess(
        data,
        total,
        perPage,
        sort
      )
    )
  } catch (error) {
    console.log('error: ', error)
  }
}

export function* participantsListWatcherSaga() {
  yield takeLatest(
    fromActions.PARTICIPANTS_PROFILES_LIST,
    participantsListEffectSaga
  )
}
